var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "filter-suggestions-modal" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "ai-section" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "ai-input-wrapper" },
        [
          _c("S2Textarea", {
            ref: "aiTextarea",
            attrs: {
              rows: 3,
              placeholder:
                "Örn: Son 11 gün içinde WhatsApp kanalından gelen VIP müşteriler",
              disabled: _vm.isGenerating,
            },
            model: {
              value: _vm.aiPrompt,
              callback: function ($$v) {
                _vm.aiPrompt = $$v
              },
              expression: "aiPrompt",
            },
          }),
          _vm._v(" "),
          _c(
            "SupsisButton",
            {
              staticClass: "ai-generate-btn",
              attrs: {
                primary: "",
                disabled: !_vm.aiPrompt || _vm.isGenerating,
              },
              on: { click: _vm.generateAiFilter },
            },
            [
              !_vm.isGenerating
                ? _c("i", { staticClass: "material-icons" }, [
                    _vm._v("auto_fix_high"),
                  ])
                : _c("a-spin", { attrs: { spinning: true, size: "small" } }),
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm.isGenerating ? "Oluşturuluyor..." : "Filtre Oluştur"
                  ) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isGenerating
        ? _c(
            "div",
            { staticClass: "progress-indicator" },
            [
              _c("a-spin", { attrs: { spinning: true, size: "small" } }),
              _vm._v(" "),
              _c("span", [_vm._v("Filtreniz oluşturuluyor...")]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.aiFilterResult
        ? _c("div", { staticClass: "ai-result-container" }, [
            _c("div", { staticClass: "result-header" }, [
              _c("h3", { staticClass: "result-title" }, [
                _vm._v(_vm._s(_vm.aiFilterResult.title)),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "result-description" }, [
                _vm._v(_vm._s(_vm.aiFilterResult.description)),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filters-container" }, [
              _c("div", { staticClass: "filters-count" }, [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("check_circle"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.aiFilterResult.filters.length) + " Filtre Kuralı"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filters-grid" },
                _vm._l(_vm.aiFilterResult.filters, function (filter, index) {
                  return _c(
                    "div",
                    { key: filter.id || index, staticClass: "filter-item" },
                    [
                      _c("div", { staticClass: "filter-number" }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "filter-body" }, [
                        _c("div", { staticClass: "filter-label" }, [
                          _vm._v(_vm._s(_vm.getFilterFieldLabel(filter.field))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "filter-value-row" }, [
                          filter.operator
                            ? _c("span", { staticClass: "filter-operator" }, [
                                _vm._v(
                                  _vm._s(_vm.getOperatorLabel(filter.operator))
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "filter-value" }, [
                            _vm._v(
                              _vm._s(_vm.formatFilterValueDisplay(filter))
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.debugMode
                ? _c("div", { staticClass: "debug-panel" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("pre", { staticClass: "debug-code" }, [
                      _vm._v(
                        _vm._s(
                          JSON.stringify(_vm.aiFilterResult.filters, null, 2)
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "result-actions" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: { primary: "", block: "" },
                    on: { click: _vm.createFilterFromAi },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                    _vm._v(
                      "\n                    Filtreyi Oluştur\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { ghost: "" },
                    on: {
                      click: function ($event) {
                        _vm.aiFilterResult = null
                      },
                    },
                  },
                  [_vm._v("\n                    İptal\n                ")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "example-prompts" }, [
        _c("h4", [_vm._v("Örnek Promptlar")]),
        _vm._v(" "),
        _c("div", { staticClass: "prompt-slider-container" }, [
          _c(
            "div",
            { ref: "slider", staticClass: "prompt-slider" },
            _vm._l(_vm.examplePrompts, function (prompt, index) {
              return _c("div", { key: index, staticClass: "prompt-slide" }, [
                _c(
                  "div",
                  {
                    staticClass: "prompt-card",
                    on: {
                      click: function ($event) {
                        return _vm.selectExamplePrompt(prompt)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("lightbulb"),
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(prompt))]),
                  ]
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "slider-controls" },
            [
              _c(
                "a-button",
                {
                  staticClass: "control-btn prev",
                  on: { click: _vm.slidePrev },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_left"),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "control-btn next",
                  on: { click: _vm.slideNext },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("chevron_right"),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "templates-section" }, [
      _c("div", { staticClass: "section-header" }, [
        _c("h3", { staticClass: "section-title" }, [_vm._v("Hazır Şablonlar")]),
        _vm._v(" "),
        _c("div", { staticClass: "search-box" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("search")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            staticClass: "search-input",
            attrs: { type: "text", placeholder: "Şablonlarda ara..." },
            domProps: { value: _vm.searchQuery },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchQuery = $event.target.value
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-groups" },
        _vm._l(_vm.filterGroups, function (group) {
          return _c(
            "div",
            {
              key: group.id,
              staticClass: "group-badge",
              class: { active: _vm.selectedGroup === group.id },
              on: {
                click: function ($event) {
                  return _vm.selectGroup(group.id)
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(group.icon)),
              ]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(group.name))]),
              _vm._v(" "),
              _c("span", { staticClass: "group-count" }, [
                _vm._v(_vm._s(_vm.getGroupTemplateCount(group.id))),
              ]),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "templates-slider-container" }, [
        _c(
          "div",
          { ref: "templatesSlider", staticClass: "templates-grid" },
          _vm._l(_vm.paginatedTemplates, function (page, pageIndex) {
            return _c(
              "div",
              { key: pageIndex, staticClass: "template-slide" },
              _vm._l(page, function (template) {
                return _c(
                  "div",
                  {
                    key: template.id,
                    staticClass: "template-card",
                    class: { "multi-filter": template.filters.length > 1 },
                    on: {
                      click: function ($event) {
                        return _vm.selectTemplate(template)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "template-icon",
                        style: { background: template.color },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(template.icon)),
                        ]),
                        _vm._v(" "),
                        template.filters.length > 1
                          ? _c("span", { staticClass: "filter-count" }, [
                              _vm._v(_vm._s(template.filters.length)),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "template-info" }, [
                      _c("h4", { staticClass: "template-name" }, [
                        _vm._v(_vm._s(template.name)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "template-desc" }, [
                        _vm._v(_vm._s(template.description)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "slider-controls" },
          [
            _c(
              "a-button",
              {
                staticClass: "control-btn prev",
                on: { click: _vm.slideTemplatesPrev },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("chevron_left"),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "control-btn next",
                on: { click: _vm.slideTemplatesNext },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("chevron_right"),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("div", { staticClass: "header-left" }, [
        _c("div", { staticClass: "header-icon" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("tune")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "header-text" }, [
          _c("h2", { staticClass: "header-title" }, [
            _vm._v("Filtre Önerileri"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "header-subtitle" }, [
            _vm._v(
              "AI asistan ile özel filtre oluşturun veya hazır şablonları kullanın"
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ai-header" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("auto_awesome")]),
      _vm._v(" "),
      _c("span", [_vm._v("AI Asistan")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "debug-title" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
      _vm._v("\n                        Filters JSON\n                    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }